import { buildApplicationPath, buildApplicationSourcePath, normalizeApplicationModule } from '../../utils/applicationRoutes';
import { buildPdfWorkflowPath } from '../pdf/workflowRoutes';

const WORKFLOW_ROUTE_ROOTS = {
  brd: 'pdf',
  requirements: 'requirements',
  api: 'api-testing',
  excel: 'excel-testcases',
};

const findSectionNumber = (job, items) => (
  (items || []).find((item) => Number(item?.section_number) > 0)?.section_number
  || job?.artifact_refs?.find((ref) => Number(ref?.section_number) > 0)?.section_number
  || job?.result_summary?.section_number
);

export const destinationForJob = (job, items = []) => {
  if (!job?.application_id) return null;

  const module = normalizeApplicationModule(job.module);
  if (!module || !(job.source_id || job.pdf_id)) {
    return { href: buildApplicationPath(job.application_id), label: 'Open application' };
  }

  const sourceId = job.source_id || job.pdf_id;
  const routeRoot = WORKFLOW_ROUTE_ROOTS[module];
  if (!routeRoot) {
    return {
      href: buildApplicationSourcePath(job.application_id, module, sourceId),
      label: 'Open source',
    };
  }

  const sectionNumber = findSectionNumber(job, items);
  const isCompleted = ['completed', 'partial_completed'].includes(String(job.status || '').toLowerCase());
  const isGeneration = ['test_case_generation', 'test_case_regeneration'].includes(job.type);

  if (job.type === 'test_pre_analysis' && sectionNumber) {
    return {
      href: `${buildPdfWorkflowPath({ applicationId: job.application_id, routeRoot, pdfId: sourceId, sectionNumber, step: 3.5 })}?planning_job_id=${encodeURIComponent(job.id)}`,
      label: 'Open section plan',
    };
  }

  if (isGeneration && isCompleted && sectionNumber && items.length <= 1) {
    return {
      href: `${buildPdfWorkflowPath({ applicationId: job.application_id, routeRoot, pdfId: sourceId, sectionNumber, step: 5 })}?source=history`,
      label: 'Open completed test cases',
    };
  }

  if (isGeneration) {
    return {
      href: buildPdfWorkflowPath({ applicationId: job.application_id, routeRoot, pdfId: sourceId, step: 4, bulkJobId: job.id }),
      label: 'Open generation',
    };
  }

  if (job.type === 'document_extraction' || job.type === 'manual_input_ingestion') {
    return {
      href: buildPdfWorkflowPath({ applicationId: job.application_id, routeRoot, pdfId: sourceId, step: 3 }),
      label: 'Open workflow',
    };
  }

  if (job.type === 'playwright_script_generation' && sectionNumber) {
    return {
      href: buildPdfWorkflowPath({ applicationId: job.application_id, routeRoot, pdfId: sourceId, sectionNumber, step: 7 }),
      label: 'Open workflow',
    };
  }

  return {
    href: buildApplicationSourcePath(job.application_id, module, sourceId),
    label: 'Open source',
  };
};
